import { AiOutlineVerticalAlignTop } from "react-icons/ai";
import "./Totop.css";
export default function Totop() {
  return (
    <div className="totop-wrapper">
      <a href="#home"><AiOutlineVerticalAlignTop className="totop-icon" /></a>
      
    </div>
  );
}
